import { createTRPCReact } from "@trpc/react-query";
import type { AppRouter } from "@laborup/nova-client";

export const novaClient = createTRPCReact<AppRouter>();
